<template>
    <div class="text-md-center">
        <v-container grid-list-md text-xs-center>
            <div id="error" v-if="urlPourFormulaire || mdpOK != crypter(mdpAdmin)">
                <p caption class="center headline red--text">Ecole indisponible. Contactez l'administrateur</p>
                <v-layout row wrap xs12 v-if="!urlPourFormulaire">
                    <v-flex xs4></v-flex>
                    <v-flex xs4>
                        <v-text-field v-model="mdpAdmin"
                                      label="Mot de passe admin"
                                      :append-icon="show ? 'visibility' : 'visibility_off'"
                                      @click:append="show = !show"
                                      :type="show ? 'text' : 'password'">
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </div>
        </v-container>
        <div id="accueil" v-if="mdpOK == crypter(mdpAdmin)">
            <h1 class="text-uppercase font-weight-black">Choix du formulaire</h1>
            <div mt-5>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/ece')">
                    Formulaire ECE
                    <v-icon right>edit</v-icon>
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn class="mr-3 mb-2" small @click="$router.push('/bachelorsesce')">
                    Formulaire Bachelors ESCE
                    <v-icon right>edit</v-icon>
                </v-btn>

                <v-btn class="mr-3 mb-2" small @click="$router.push('/reboostesce')">
                    Formulaire Reboost ESCE
                    <v-icon right>edit</v-icon>
                </v-btn>

                <v-btn class="mr-3 mb-2" small @click="$router.push('/rentreedecaleeesce')">
                    Formulaire Rentrée décalée ESCE
                    <v-icon right>edit</v-icon>
                </v-btn>

                <v-btn class="mr-3 mb-2" small @click="$router.push('/mscesce')">
                    Formulaire Msc Esce
                    <v-icon right>edit</v-icon>
                </v-btn>

                <v-btn class="mr-3 mb-2" small @click="$router.push('/internationalesce')">
                    Formulaire International ESCE
                    <v-icon right>edit</v-icon>
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/ebs')">
                    Formulaire EBS
                    <v-icon right>edit</v-icon>
                </v-btn>

                <v-btn class="mr-3 mb-2" small @click="$router.push('/rentreedecaleeebs')">
                    Formulaire Rentrée décalée EBS
                    <v-icon right>edit</v-icon>
                </v-btn>

                <v-btn class="mr-3 mb-2" small @click="$router.push('/ium')">
                    Formulaire IUM
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/heip')">
                    Formulaire Heip
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/ceds')">
                    Formulaire CEDS
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-spacer></v-spacer>

                <v-btn class="mr-3 mb-2" small @click="$router.push('/supcareer')">
                    Formulaire SupCareer
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/supdecreation')">
                    Formulaire Sup de Création
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/supdepub')">
                    Formulaire Sup De Pub
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/supcareervae')">
                    Formulaire Sup Career Vae
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/supcareercourssoir')">
                    Formulaire Sup Career Cours du soir
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/isbe')">
                    Formulaire ISBE
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/inseecbba')">
                    Formulaire BBA INSEEC (anciennement Bachelors BBA)
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/bachelorsinseec')">
                    Formulaire Bachelors INSEEC
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/mastersinseec')">
                    Formulaire Master INSEEC
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/international')">
                    Formulaire INTERNATIONAL
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/dbaesce')">
                    Formulaire DBA
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/phdesce')">
                    Formulaire PHD
                    <v-icon right>edit</v-icon>
                </v-btn>
                <v-btn class="mr-3 mb-2" small @click="$router.push('/inseecbts')">
                    INSEEC BTS
                    <v-icon right>edit</v-icon>
                </v-btn>
            </div>
            <br /><br /><br />
            <div>
                <v-snackbar v-model="snackbar" :color="colorSnackbar">
                    {{messageSnackbar}}
                </v-snackbar>
                <h1 class="text-uppercase font-weight-black">Administration</h1>
                <v-btn :loading="loadingCache" @click="majCacheCatalogues">
                    Mettre à jour le cache des catalogues et des établissements
                    <v-icon right color="success">refresh</v-icon>
                </v-btn>
            </div>
        </div>
    </div>
</template>
<script>
    import md5 from 'js-md5'

    export default {
        name: 'accueil',

        data() {
            return {
                // Flag pour dire si on est redirigé à partir du service de paiement
                urlPourFormulaire: false,
                mdpAdmin: null,
                mdpOK: '02e24af125492785bc83b2db32cff1d0',
                show: false,
                loadingCache: false,
                errorCacheCatalogue: false,
                errorCacheEntite: false,
                snackbar: false
            }
        },

        computed: {
            // Color snackbar
            colorSnackbar() {
                if (this.errorCacheCatalogue || this.errorCacheEntite) {
                    return "error"
                }

                return "warning"
            },

            // Message snackbar
            messageSnackbar() {
                if (this.errorCacheCatalogue || this.errorCacheEntite) {
                    return "Erreur mise à jour cache !"
                }

                return "Le cache est remis à jour"
            },
        },

        methods: {
            crypter(chaine) {
                return chaine ? md5(chaine) : chaine;
            },

            // Mattre à jour le cache des catalogue à partir de la base
            majCacheCatalogues() {
                // Activer le flag de chargement
                this.loadingCache = true
                this.$storeCandidature.ChargerConfiguration(null, null, true)
                    .then(response => {
                        // Success
                        if (response.data) {
                            // Arréter le flag de chargement
                            this.errorCacheCatalogue = false
                            this.loadingCache = false
                            this.snackbar = true
                        }
                        else {
                            // Arréter le flag de chargement
                            this.errorCacheCatalogue = true
                            this.loadingCache = false
                            this.snackbar = true
                        }
                    }).catch(() => {
                        // Arréter le flag de chargement
                        this.errorCacheCatalogue = true
                        this.loadingCache = false
                        this.snackbar = true

                    });

                // Mettre à jour le cache des établissements
                this.$http.post("EtablissementFrequente", null, { params: { groupINSEEC: true, reloadCache: true } })
                    .then(response => {
                        // Success
                        if (response.data) {
                            // Arréter le flag de chargement
                            this.errorCacheEntite = false
                            this.loadingCache = false
                            this.snackbar = true
                        }
                        else {
                            // Arréter le flag de chargement
                            this.errorCacheEntite = true
                            this.loadingCache = false
                            this.snackbar = true
                        }
                    }).catch(() => {
                        // Arréter le flag de chargement
                        this.errorCacheEntite = true
                        this.loadingCache = false
                        this.snackbar = true

                    });
            }
        },

        created() {
            // Détecter s'il y en a un param url pay
            if (this.$route.query.pay || this.$route.query.cdt || this.$route.query.kr) {
                this.urlPourFormulaire = true
            }
        }
    }
</script>

